import React, { Component } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

class Rooms extends Component {
    render() {
        const { data } = this.props;
        
        var settings = {
            dots: false,
            arrows: true,
            speed: 3000,
            slidesToShow: 3,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2500,
            responsive: [
                {
                    breakpoint: 1440,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        infinite: true,
                    }
                },
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        infinite: true,
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        };

        return (
            <div className="room-slide-area section-padding">
                <div className="Room-carousel">
                    <Slider {...settings}>
                        {data?.images?.length > 0 ? (
                            data.images.map((image, index) => (
                                <div key={index} className="item">
                                    <div className="destination-item">
                                        <div className="destination-img">
                                            <img 
                                            style={{ width: '626px', height: '500px', objectFit: 'cover' }}
                                            src={`${window.location.origin}/${image}`}  alt={`Destination ${index + 1}`} />
                                        </div>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <p>No images available</p>
                        )}
                    </Slider>
                </div>
            </div>

        );
    }
}

export default Rooms;